import { connect } from 'react-redux'

import { getSurveyResults } from './surveyResults.actions'
import PostCallSurveyPanel, { UnstyledPostCallSurveyPanel } from './PostCallSurvey'

const mapStateToProps = (
  {
    media: {
      survey,
      main: { contact },
    },
  },
  { t },
) => {
  return {
    loading: survey.loading,
    error: survey.error,
    survey: survey.data,
    surveyScoreOverride: contact.data ? contact.data.surveyScore : t('na'),
  }
}

const mapDispatchToProps = dispatch => ({
  async onContactUpdate(contactId) {
    const surveyResults = dispatch(getSurveyResults(contactId))
    await surveyResults
  },
})

export { UnstyledPostCallSurveyPanel }

export default connect(mapStateToProps, mapDispatchToProps)(PostCallSurveyPanel)
